import { InitPage } from "../index";

declare let selectedTransfers: any;
declare let baseTransfer: any;

class TransferOut {
  selectedTransfers = [];
  baseTransfer = {};
  init() {
    const _this = this;

    $("#mergeBtn").click(function (e) {
      e.preventDefault();
      if (selectedTransfers.length === 0) {
        alert("Please select at least two items.");
        return;
      }

      $("#showModal").modal("show");
      $("#selectedTransfersSpan").html(selectedTransfers.join(", "));
      $("#selected_transfers").val(selectedTransfers.join(","));
      let selectBox = $("#base_transfer");
      selectBox.html("");
      selectedTransfers.forEach((transfer) => {
        let option = document.createElement("option");
        option.text = transfer;
        option.value = transfer;
        selectBox.append(option);
      });
    });

    $("#select_all").on("change", function (e) {
      // @ts-ignore
      const checked = e.target.checked;
      $('input[type="checkbox"].transfers-checkbox:not(:disabled)').prop(
        "checked",
        checked,
      );
      $(".transfers-checkbox").trigger("change");
    });

    $(".transfers-checkbox").on("change", function () {
      var el = $(this);
      if ($(el).is(":checked") == true) {
        selectedTransfers.push(el.data("id"));
        $("#bulk-close-btn").removeClass("disabled");
        $('#bulk-expected-by-update').removeClass('disabled');
        if (selectedTransfers.length == 1) {
          baseTransfer = {
            id: el.data("id"),
            recieved_quantity: el.data("recieved-quantity"),
            to_number: el.data("to-number"),
          };
        } else if (selectedTransfers.length > 1) {
          $("#mergeBtn").prop("disabled", _this.disabled());
        }
      } else {
        selectedTransfers = selectedTransfers.filter(function (value) {
          return value !== el.data("id");
        });

        if (selectedTransfers.length == 0) {
          $("#bulk-close-btn").addClass("disabled");
          $('#bulk-expected-by-update').addClass('disabled');
          baseTransfer = {};
        }

        $("#mergeBtn").prop(
          "disabled",
          selectedTransfers.length < 2 || _this.disabled(),
        );
      }

      $("#select_all").prop(
        "checked",
        $('input[type="checkbox"].transfers-checkbox:not(:disabled)').length ===
          $(".transfers-checkbox:checked").length,
      );
    });

    $(document).on("click", "#bulk-close-btn", function (e) {
      e.preventDefault(); // Prevent default link behavior

      const selectedIds = $(".transfers-checkbox:checked")
        .map(function () {
          return $(this).val();
        })
        .get();

      if (selectedIds.length === 0) {
        alert("Please select at least one item.");
        return;
      }

      const url = $(this).attr("href");

      $.ajax({
        url: url,
        method: "GET",
        data: { id: selectedIds },
        dataType: "script",
      });
    });

    $(document).on("click", "#bulk-expected-by-update", function (e) {
      e.preventDefault();

      const selectedIds = $(".transfers-checkbox:checked")
        .map(function () {
          return $(this).val();
        })
        .get();

      if (selectedIds.length === 0) {
        alert("Please select at least one item.");
        return;
      }

      $('#bulk_expected_by_update').find('input[name="transfer_ids"]').val(selectedIds.join(','));
      $('#selected-transfers-span').text(selectedIds.length);
      $('#bulk_expected_by_update').modal('show');
    });
  }

  disabled() {
    let disabled = false;

    $(".transfers-checkbox:checked").each(function () {
      let element = $(this);

      if (
        element.data("to-number") != baseTransfer.to_number ||
        element.data("recieved-quantity") != 0
      ) {
        disabled = true;
        return false; // Exit early
      }
    });

    return disabled;
  }
}

export function LoadPage() {
  InitPage("transfer_out", () => {
    const transfer_out = new TransferOut();
    transfer_out.init();
  });
}
